module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ShinglesList-1ba93d731f0de11e86011ff358971603.jpg";